import type { ContactUsConfig } from './types'
import { commonTexts } from './common'

export const contactUsConfig: ContactUsConfig = {
  texts: commonTexts,
  colors: {
    bgPrimary: '#FDF6F7',
    bgTertiary: '#FFFFFF',
    textPrimary: '#402A33',
    textTertiary: '#9C8590',
    textPlaceholder: '#C7B3BC',
    accentRed: '#E4587F',
    primaryColor: '#E4587F',
    whiteColor: '#FFFFFF',
  },
}
